module.exports = __webpack_public_path__ + "docs/wap-1.7.pdf";